import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { AssignPartnerForm } from "../Components/Form/AssignPartnerForm";

const formResource = Resources.base.order.editForm;

type AssignPartnerCardWidgetProps = {
	order: OrderDetailResponseDto;
};

export function AssignPartnerCardWidget({
	order,
}: AssignPartnerCardWidgetProps) {
	const { t } = useResource();
	return (
		<BaseCard title={t(formResource.partnerTitle)}>
			<AssignPartnerForm order={order} />
		</BaseCard>
	);
}
